import { PlusIcon } from "lucide-react";
import { Button } from "@/shared/components/ui/button";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import { CreateMatrixDialog } from "../../../components/create-matrix-dialog";

export function MatrixEmptyState() {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">No matrices yet</CardTitle>
        <CardDescription>
          Create a matrix to start structuring your research findings.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <CreateMatrixDialog
          trigger={
            <Button className="gap-1.5">
              <PlusIcon className="size-4" />
              New Matrix
            </Button>
          }
        />
      </CardContent>
    </Card>
  );
}
